export default __webpack_public_path__ + "static/media/SAP.980c0172.png";